<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        icon="mdi-pencil"
        variant="text"
        size="small"
        color="primary"
        @click.stop
      ></v-btn>
    </template>

    <v-card prepend-icon="mdi-account-multiple" title="Edit Team">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6" lg="6" sm="12">
            <v-text-field
              density="compact"
              placeholder="Team name*"
              prepend-inner-icon="mdi-information"
              variant="outlined"
              v-model="form.team_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="6" sm="12">
            <v-text-field
              density="compact"
              placeholder="Team description*"
              prepend-inner-icon="mdi-card-account-details"
              variant="outlined"
              v-model="form.team_desc"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-alert
          type="info"
          density="compact"
          variant="tonal"
          class="mt-1 mb-1"
          text="Renaming a team automatically reassigns its members to the new name."
        ></v-alert>

        <v-alert
          v-if="errorMessage"
          type="error"
          density="compact"
          variant="tonal"
          class="mt-2"
        >
          {{ errorMessage }}
        </v-alert>

        <small class="text-caption text-medium-emphasis">*indicates required field</small>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>
        <v-btn
          color="primary"
          text="Save"
          variant="flat"
          :loading="saving"
          @click="save()"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import constant from '@/constant';
import utils from '@/utils';

export default {
  name: "EditTeam",
  props: {
    team: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      constant: constant,
      dialog: false,
      saving: false,
      errorMessage: "",
      form: {
        team_name: "",
        team_desc: ""
      }
    };
  },
  watch: {
    dialog(open) {
      if (open) {
        this.errorMessage = "";
        this.form = {
          team_name: this.team.team_name || "",
          team_desc: this.team.team_desc || ""
        };
      }
    }
  },
  methods: {
    save() {
      this.saving = true;
      this.errorMessage = "";

      const f = new FormData();
      f.append("id", this.team.id);
      f.append("team_name", this.form.team_name);
      f.append("team_desc", this.form.team_desc);

      axios.post(utils._api(this.constant.update_team), f, {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      }).then((response) => {
        this.saving = false;
        this.dialog = false;
        this.$emit('toggle-message', response.data.message);
      }).catch((error) => {
        this.saving = false;
        const data = error.response && error.response.data;
        if (data && data.errors) {
          this.errorMessage = Object.values(data.errors).flat().join(' ');
        } else {
          this.errorMessage = (data && data.message) || "Update failed.";
        }
      });
    }
  }
};
</script>
